import { NotifyType } from 'app/projects/shared/src/lib/enums/notify-type.enum';
import { RelevantExecution } from 'app/library/program-item/models/relevant-execution.model';
import { ProgramArchiveOption } from '../enums/program-archive-option.enum';
import { Module } from './module.model';

export class ModuleStatusCommand {
    status: string;
    notify: NotifyType;
    archive_option?: ProgramArchiveOption;

    constructor(tempModule: Module | RelevantExecution, notify?: NotifyType, archiveOption?: ProgramArchiveOption) {
        this.status = tempModule.status;
        this.notify = notify;
        if (archiveOption) {
            this.archive_option = archiveOption;
        }
    }
}
